<template>
  <div>
    <toolbar transparent fixed :logo="false" :back="false">
      <template v-slot:left>
        <div class="v-toolbar__button" @click="confirmExit">
          <v-icon icon="close" />
        </div>
      </template>
    </toolbar>

    <alert-dialog
      :title="$t('components.workout.sessionToolbar.dialogLeaveWorkoutTitle')"
      :actions="[
        {
          title: $t('components.workout.sessionToolbar.dialogLeaveWorkoutNo'),
          callback: resume
        },
        {
          title: $t(
            'components.workout.sessionToolbar.dialogLeaveWorkoutFinish'
          ),
          callback: complete
        }
      ]"
      :show="showDialog"
      @close="resume"
    >
      {{ $t("components.workout.sessionToolbar.dialogLeaveWorkoutContent") }}
    </alert-dialog>
  </div>
</template>

<script>
import EventBus, { EVENTS } from "@/lib/event-bus"

import Toolbar from "@/components/Toolbar"
import AlertDialog from "@/components/AlertDialog"

export default {
  components: {
    Toolbar,
    AlertDialog
  },

  data() {
    return {
      showDialog: false
    }
  },

  methods: {
    resume() {
      this.showDialog = false
      this.$emit("resume")
      EventBus.$emit(EVENTS.WORKOUT_RESUMED)
    },

    complete() {
      this.showDialog = false
      this.$emit("complete")
    },

    confirmExit() {
      this.$emit("exitAttempted")
      EventBus.$emit(EVENTS.WORKOUT_EXIT_ATTEMPTED)
      this.showDialog = true
    }
  }
}
</script>
